import React, { Component } from "react";
import { withRouter , Link} from "react-router-dom";
import { connect } from 'react-redux';
import { exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, saveState, deleteState } from "../../providers/actions";
import { mostraAguardando, escondeAguardando } from "../../providers/actions";
import { Message } from "../Message/Message";
import { Loading } from "../Loading/Loading";
import { ConfirmModal } from "../ConfirmModal/ConfirmModal";
import { Pagination } from "../Pagination/Pagination";
import { ButtonBack } from "../Button/Back";
import SelectSearch from "../UI/SelectSearch/SelectSearch"
import api from "../../services/api";
import './Analist.css';
import { getMessagemErro } from "../../utils/erro";

const mapDispatchToProps = { saveState, deleteState, exibeMensagemSucesso, exibeMensagemErro, limpaMensagem, mostraAguardando, escondeAguardando }

const mapStateToProps = (state) => {
	return {
		user: state.usuarioStore.user,
		filters: state.filterStore,
	}
}

export const AnalistList =

withRouter(

// redux
connect(
	(mapStateToProps), 
	(mapDispatchToProps)
)(

	class extends Component {

		constructor(props){
			super(props);
			this.initialState = {
				orgaos: [],
				orgao: '',
				fornecedoras: [],
				fornecedorasTodas: [],
				fornecedora: '',
				resultadoPesquisa: {},
				pesquisaExecutada : false,
			};

			this.state = this.initialState;
			this.handleInputChange = this.handleInputChange.bind(this);
			this.handleOrgaoChange = this.handleOrgaoChange.bind(this);
			this.pesquisar = this.pesquisar.bind(this);
			this.executaPesquisaPaginada = this.executaPesquisaPaginada.bind(this);
			this.limparPesquisa = this.limparPesquisa.bind(this);
			this.fecharModais = this.fecharModais.bind(this);
		}

		render() {
			return (
				<main id="content" className="page-content p-3">
					<Message />
					<Loading />
					<div style={{margin: "10px"}}>
						<h1>Analistas</h1>
					</div>
					<div className="div-form1">
						{this.renderForm()}
					</div>
				</main>
			);
		}

		componentDidMount(){
			this.props.limpaMensagem();
			
			this.setState({carregandoOrgaos : true});
			api.get('/api/analista/orgaos')
			.then(response => { this.setState({
					orgaos: response.data,
					carregandoOrgaos: false
				}) 
			})
			.catch(erro => {
				this.setState({carregandoOrgaos : false});
				console.log("Não foi possível recuperar órgãos " + erro)
				this.props.exibeMensagemErro("Erro durante o carregamento da página")
			});

			this.setState({carregandoApis: true});
			api.get('/api/aplicacao-fornecedora')
			.then(response => { 
				const fornecedoras = response.data;

				this.setState(
					{
						fornecedoras,
						fornecedorasTodas: [...fornecedoras],
						carregandoApis: false
					}
				)
			 })
			.catch(erro => {
				this.setState({carregandoApis: false});
				console.log("Não foi possível recuperar as aplicações fornecedoras " + erro)
				this.props.exibeMensagemErro("Erro durante o carregamento da página")
			});

			if (!this.props.location.state?.resetSearch) {
				this.executarPesquisaAnterior();
			}
		}

		renderForm() {
			const { resultadoPesquisa, pesquisaExecutada } = this.state;
			const { content } = resultadoPesquisa;
			const usuario = this.props.user;

			return(
				<div className="container-fluid">

					<ConfirmModal titulo="Confirmação" 
						visible={this.state.exibeModalExcluir}
						handleOk={() => this.excluirAnalista()}
						handleCancel={() => this.fecharModais()}
						message="Deseja realmente remover o analista?"/>

					<div className="br-form">
						<div className="row">
							<div className="col-md-6">
								<div className="field">
									<div className="input">
										<label htmlFor='orgao'>Órgão:</label>
										{this.state.carregandoOrgaos === false &&
											<SelectSearch
												id="orgao"
												name="orgao"
												options={this.state.orgaos.map(orgao => ({ value: orgao.id, label: orgao.nome }))}
												includeAllOption={true}
												onChange={this.handleOrgaoChange}
												value={this.state.orgao}
											/>
										}
										{this.state.carregandoOrgaos === true && 
											<button className="br-button is-secondary is-circle is-loading" type="button"/>
										}
									</div>
								</div>
							</div>
						
							<div className="col-md-6">
								<div className="field">
									<div className="input">
										<label>API:</label>
										{this.state.carregandoApis === false &&
											<SelectSearch
												id="fornecedora"
												name="fornecedora"
												options={this.state.fornecedoras.map(fornecedora => ({ value: fornecedora.id, label: fornecedora.nome }))}
												includeAllOption={true}
												allOptionName="Todas"
												onChange={this.handleInputChange}
												value={this.state.fornecedora}
											/>
										}
										{this.state.carregandoApis === true && 
										<button className="br-button is-secondary is-circle is-loading" type="button"/>
									}
									</div>
								</div>
							</div>	
						</div>

						<div className="actions-button">
							<div className="actions justify-content-start">
								<button type="button" className="button is-primary" onClick={this.pesquisar}>Pesquisar</button>
								<button type="button" className="button is-secondary" onClick={() => this.limparPesquisa()}>Limpar</button>
								<Link to="/analist/new"> 
									<button type="button" className="button is-secondary mr-3">Novo</button>
								</Link>
								<ButtonBack />
							</div>
						</div>

						{(content && content.length > 0) &&	
							<div className="br-table">						
								<div className="table">
									<table>
										<thead>
											<tr>
											<th scope="col">Órgão</th>
											<th scope="col">API</th>
											<th scope="col">Nome</th>
											<th scope="col">E-mail</th>
											<th className="text-center" scope="col">Ações</th>
											</tr>
										</thead>
										
										<tbody>
											{ content.map((analista, index) =>
													<tr key={index} >
														<td>{analista.nomeOrgao}</td>
														<td>{analista.nomeApi}</td>
														<td>{analista.nome}</td>
														<td>{analista.email}</td>

														<td className="text-center">
															<div className="actions">
															{ (usuario.isMantenedor === true ) && 
																<>
																<button type="button" onClick={() => this.confirmarExclusao(analista)} disabled={this.state.botoesHabilitados === false} title="Excluir Analista">
																		<span className="sr-only">Excluir</span>
																		<i className="fas fa-trash"></i>
																	</button>
																	<Link to={`/analist/edit/${analista.id}`}>
																		<button type="button" title="Editar Analista">
																			<span className="sr-only">Editar</span>
																			<i className="fas fa-edit"></i>
																		</button>
																	</Link>
																	
																</>
																}
															</div>
														</td>


													</tr>
												)}
										</tbody>
									</table>
									<Pagination totalPaginas={resultadoPesquisa.totalPages} paginaAtual={resultadoPesquisa.number} onChangePage={this.executaPesquisaPaginada}/>
								</div>
							</div>
						}

						{(pesquisaExecutada && (! content || content.length === 0)) &&
							<div>
								Nenhum analista encontrado com os critérios informados.
							</div>
						}

					</div>
				</div>

				
			);
		}

		handleInputChange(evento){
			const target = evento.target;
			const nome = target.name;
			const valor = target.type === 'checkbox' ? target.checked : target.value;
			this.setState({[nome]: valor});
		}

		handleOrgaoChange(evento){
			const idOrgao =  evento.target.value;
			let fornecedoras = [];
			
			const usuario = this.props.user;

			if(usuario.isMantenedor === true && idOrgao && idOrgao !== ""){
				this.setState({ carregandoApis: true })
				api.get(`/api/orgao/${idOrgao}/fornecedoras`)
				.then(response => { 
					this.setState(
						{
							fornecedoras: response.data,
							carregandoApis: false
						}
					);
				})
				.catch(erro => {
					this.setState({ carregandoApis: false })
					console.log("Não foi possível recuperar as aplicações fornecedoras associadas ao órgão " + JSON.stringify(erro));
					this.props.exibeMensagemErro("Erro durante o carregamento das API's do órgão.")
				});
			} else {
				fornecedoras = this.state.fornecedorasTodas;
			}


			this.setState({
				orgao: idOrgao,
				fornecedora: '',
				fornecedoras,
			});
		}

		confirmarExclusao(analista) {
			this.setState(
				{
					exibeModalExcluir: true,
					analistaAlvo: analista,
				}
			);
		}

		excluirAnalista(){
			this.props.limpaMensagem();
			const analista = this.state.analistaAlvo;
			let url = `/api/analista/${analista.id}`;
			const options = {
				method: 'delete',
				url,
			}
			this.props.mostraAguardando(); 
			this.setState({botoesHabilitados:false});

			api(options)
				.then(response => {
					const mensagem = 'Analista excluído com sucesso!';
					this.props.exibeMensagemSucesso(mensagem);
					this.executarPesquisaAnterior();
				})
				.catch(erro => {
					const msg = getMessagemErro("Não foi possível excluir o analista.", erro);
					console.log(JSON.stringify(msg));
					this.props.exibeMensagemErro(msg.mensagem, msg.erros);
					
				})
				.then (() =>{
					this.props.escondeAguardando();
					this.setState({botoesHabilitados:true});
				});   
			
			this.fecharModais();
		}

		executarPesquisaAnterior() {
			const lastState = this.props.filters[this.props.location.pathname];
			
			this.setState({
				...this.initialState,
				...lastState,
				pesquisaExecutada: false,
				resultadoPesquisa: {}
			}, () => {
				if (lastState) {
					const lastPage = lastState ? lastState?.resultadoPesquisa?.number : 0;
					this.executaPesquisaPaginada(lastPage);
				}
			});
		}

		pesquisar (e){
			this.props.limpaMensagem();
			this.executaPesquisaPaginada(0);
			if (this.props.location.state?.resetSearch) {
				this.props.history.replace(this.props.location.pathname, {
					...this.props.location.state,
					resetSearch: false,
				  });
			}
		}

		executaPesquisaPaginada(pagina){

			const {orgao, fornecedora} = this.state;
			const criterioPesquisa = {orgao, fornecedora, pagina};
			const url = '/api/analista/paginado';

			const options = {
				method: 'post',
				url,
				data: criterioPesquisa
			}

			this.props.mostraAguardando()
			api(options)
				.then(response => { 
					this.setState({
						resultadoPesquisa: response.data,
						pesquisaExecutada : true,
					}, () => {
						this.props.saveState(this.state, this.props.location.pathname);
					}) 
				})
				.catch(erro => {
					console.log("Não foi possível recuperar os analistas. " + erro)
					this.props.exibeMensagemErro("Erro durante a execução da pesquisa")
				})
				.then( () => {
					this.props.escondeAguardando();
				});
		}

		limparPesquisa(){
			this.props.limpaMensagem();
			this.setState({
				orgao: '',
				fornecedora: '',
				fornecedoras: [...this.state.fornecedorasTodas],
				resultadoPesquisa: {},
				pesquisaExecutada : false,
			}, () => {
				this.props.deleteState(this.state, this.props.location.pathname);
			});
		}


		fecharModais () {
			this.setState(
				{
					exibeModalExcluir:false,
				}
			);
		}
	}

) // redux
); // router